// @flow
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';

class TaxFootnote extends Component<Props> {
  styles = getStyles();

  render() {
    if (this.props.isExemptedFromTax) {
      return this.props.isNotMalaysian ? (
        <Text testID="taxFootNote" style={this.styles.tax}>
          {I18n.t('tax.exclusiveDescription')}
        </Text>
      ) : null;
    } else {
      return (
        <Text testID="taxFootNote" style={this.styles.tax}>
          {I18n.t('tax.inclusiveDescription')}
        </Text>
      );
    }
  }
}

export type Props = {
  isExemptedFromTax: boolean,
  isNotMalaysian: boolean,
};

function getStyles() {
  return StyleSheet.create({
    tax: {
      fontSize: 12,
      fontStyle: 'italic',
      color: 'grey',
      marginBottom: 8,
    },
  });
}

export default TaxFootnote;
